// Sample pricing requests for each product type
// Updated to match current Quantra API with IndexDef/IndexRef system

import { normalizeQuantraRequestForApi } from './api-normalizers';

export const SAMPLE_REQUESTS: Record<string, unknown> = {
  'vanilla-swap': {
    pricing: {
      as_of_date: "2026-02-09",
      settlement_date: "2026-02-11",
      indices: [
        {
          id: "USD_3M",
          name: "USDLibor",
          index_type: "Ibor",
          currency: "USD",
          tenor_number: 3,
          tenor_time_unit: "Months",
          fixing_days: 2,
          calendar: "UnitedStatesGovernmentBond",
          day_counter: "Actual360",
          business_day_convention: "ModifiedFollowing",
          end_of_month: false
        }
      ],
      curves: [{
        id: "discount",
        day_counter: "Actual365Fixed",
        interpolator: "LogLinear",
        bootstrap_trait: "Discount",
        reference_date: "2026-02-09",
        points: [
          {
            point_type: "DepositHelper",
            point: {
              rate: 0.029,
              tenor_time_unit: "Months",
              tenor_number: 3,
              fixing_days: 2,
              calendar: "TARGET",
              business_day_convention: "ModifiedFollowing",
              day_counter: "Actual360"
            }
          },
          {
            point_type: "DepositHelper",
            point: {
              rate: 0.0275,
              tenor_time_unit: "Months",
              tenor_number: 6,
              fixing_days: 2,
              calendar: "TARGET",
              business_day_convention: "ModifiedFollowing",
              day_counter: "Actual360"
            }
          },
          {
            point_type: "SwapHelper",
            point: {
              rate: 0.025,
              tenor_time_unit: "Years",
              tenor_number: 2,
              calendar: "TARGET",
              sw_fixed_leg_frequency: "Annual",
              sw_fixed_leg_convention: "ModifiedFollowing",
              sw_fixed_leg_day_counter: "Thirty360",
              float_index: { id: "USD_3M" },
              spread: 0.0,
              fwd_start_days: 0
            }
          },
          {
            point_type: "SwapHelper",
            point: {
              rate: 0.024,
              tenor_time_unit: "Years",
              tenor_number: 5,
              calendar: "TARGET",
              sw_fixed_leg_frequency: "Annual",
              sw_fixed_leg_convention: "ModifiedFollowing",
              sw_fixed_leg_day_counter: "Thirty360",
              float_index: { id: "USD_3M" },
              spread: 0.0,
              fwd_start_days: 0
            }
          },
          {
            point_type: "SwapHelper",
            point: {
              rate: 0.027,
              tenor_time_unit: "Years",
              tenor_number: 10,
              calendar: "TARGET",
              sw_fixed_leg_frequency: "Annual",
              sw_fixed_leg_convention: "ModifiedFollowing",
              sw_fixed_leg_day_counter: "Thirty360",
              float_index: { id: "USD_3M" },
              spread: 0.0,
              fwd_start_days: 0
            }
          }
        ]
      }]
    },
    swaps: [{
      vanilla_swap: {
        swap_type: "Payer",
        fixed_leg: {
          notional: 10000000,
          schedule: {
            calendar: "TARGET",
            effective_date: "2026-02-11",
            termination_date: "2031-02-11",
            frequency: "Annual",
            convention: "ModifiedFollowing",
            termination_date_convention: "ModifiedFollowing",
            date_generation_rule: "Forward"
          },
          rate: 0.025,
          day_counter: "Thirty360",
          payment_convention: "ModifiedFollowing"
        },
        floating_leg: {
          notional: 10000000,
          schedule: {
            calendar: "TARGET",
            effective_date: "2026-02-11",
            termination_date: "2031-02-11",
            frequency: "Semiannual",
            convention: "ModifiedFollowing",
            termination_date_convention: "ModifiedFollowing",
            date_generation_rule: "Forward"
          },
          index: { id: "USD_3M" },
          spread: 0.0,
          day_counter: "Actual360",
          payment_convention: "ModifiedFollowing"
        }
      },
      discounting_curve: "discount",
      forwarding_curve: "discount"
    }]
  },

  'ois-swap': {
    pricing: {
      as_of_date: "2026-02-09",
      settlement_date: "2026-02-11",
      indices: [
        {
          id: "USD_SOFR",
          name: "SOFR",
          index_type: "Overnight",
          currency: "USD",
          fixing_days: 0,
          calendar: "UnitedStatesGovernmentBond",
          day_counter: "Actual360"
        },
        {
          id: "USD_3M",
          name: "USDLibor",
          index_type: "Ibor",
          currency: "USD",
          tenor_number: 3,
          tenor_time_unit: "Months",
          fixing_days: 2,
          calendar: "UnitedStatesGovernmentBond",
          day_counter: "Actual360",
          business_day_convention: "ModifiedFollowing",
          end_of_month: false
        }
      ],
      curves: [{
        id: "discount",
        day_counter: "Actual365Fixed",
        interpolator: "LogLinear",
        bootstrap_trait: "Discount",
        reference_date: "2026-02-09",
        points: [
          {
            point_type: "DepositHelper",
            point: {
              rate: 0.042,
              tenor_time_unit: "Months",
              tenor_number: 3,
              fixing_days: 2,
              calendar: "UnitedStatesGovernmentBond",
              business_day_convention: "ModifiedFollowing",
              day_counter: "Actual360"
            }
          },
          {
            point_type: "SwapHelper",
            point: {
              rate: 0.040,
              tenor_time_unit: "Years",
              tenor_number: 5,
              calendar: "UnitedStatesGovernmentBond",
              sw_fixed_leg_frequency: "Annual",
              sw_fixed_leg_convention: "ModifiedFollowing",
              sw_fixed_leg_day_counter: "Thirty360",
              float_index: { id: "USD_3M" },
              spread: 0.0,
              fwd_start_days: 0
            }
          }
        ]
      }]
    },
    swaps: [{
      ois_swap: {
        swap_type: "Payer",
        fixed_leg: {
          notional: 10000000,
          schedule: {
            calendar: "UnitedStatesGovernmentBond",
            effective_date: "2026-02-11",
            termination_date: "2031-02-11",
            frequency: "Annual",
            convention: "ModifiedFollowing",
            termination_date_convention: "ModifiedFollowing",
            date_generation_rule: "Forward"
          },
          rate: 0.0405,
          day_counter: "Actual360",
          payment_convention: "ModifiedFollowing"
        },
        overnight_leg: {
          notional: 10000000,
          schedule: {
            calendar: "UnitedStatesGovernmentBond",
            effective_date: "2026-02-11",
            termination_date: "2031-02-11",
            frequency: "Annual",
            convention: "ModifiedFollowing",
            termination_date_convention: "ModifiedFollowing",
            date_generation_rule: "Forward"
          },
          index: { id: "USD_SOFR" },
          spread: 0.0,
          day_counter: "Actual360",
          payment_convention: "ModifiedFollowing",
          payment_calendar: "UnitedStatesGovernmentBond",
          payment_lag: 2,
          averaging_method: "Compound",
          lookback_days: -1,
          lockout_days: 0,
          apply_observation_shift: false,
          telescopic_value_dates: false
        }
      },
      discounting_curve: "discount",
      forwarding_curve: "discount"
    }]
  },

  'basis-swap': {
    pricing: {
      as_of_date: "2026-02-09",
      settlement_date: "2026-02-11",
      indices: [
        {
          id: "USD_1M",
          name: "USDLibor",
          index_type: "Ibor",
          currency: "USD",
          tenor_number: 1,
          tenor_time_unit: "Months",
          fixing_days: 2,
          calendar: "UnitedStatesGovernmentBond",
          day_counter: "Actual360",
          business_day_convention: "ModifiedFollowing",
          end_of_month: false
        },
        {
          id: "USD_3M",
          name: "USDLibor",
          index_type: "Ibor",
          currency: "USD",
          tenor_number: 3,
          tenor_time_unit: "Months",
          fixing_days: 2,
          calendar: "UnitedStatesGovernmentBond",
          day_counter: "Actual360",
          business_day_convention: "ModifiedFollowing",
          end_of_month: false
        }
      ],
      curves: [{
        id: "discount",
        day_counter: "Actual365Fixed",
        interpolator: "LogLinear",
        bootstrap_trait: "Discount",
        reference_date: "2026-02-09",
        points: [
          {
            point_type: "DepositHelper",
            point: {
              rate: 0.042,
              tenor_time_unit: "Months",
              tenor_number: 3,
              fixing_days: 2,
              calendar: "UnitedStatesGovernmentBond",
              business_day_convention: "ModifiedFollowing",
              day_counter: "Actual360"
            }
          }
        ]
      }]
    },
    swaps: [{
      basis_swap: {
        swap_type: "Payer",
        leg1: {
          notional: 10000000,
          schedule: {
            calendar: "UnitedStatesGovernmentBond",
            effective_date: "2026-02-11",
            termination_date: "2031-02-11",
            frequency: "Monthly",
            convention: "ModifiedFollowing",
            termination_date_convention: "ModifiedFollowing",
            date_generation_rule: "Forward"
          },
          index: { id: "USD_1M" },
          spread: 0.0002,
          day_counter: "Actual360",
          payment_convention: "ModifiedFollowing"
        },
        leg2: {
          notional: 10000000,
          schedule: {
            calendar: "UnitedStatesGovernmentBond",
            effective_date: "2026-02-11",
            termination_date: "2031-02-11",
            frequency: "Quarterly",
            convention: "ModifiedFollowing",
            termination_date_convention: "ModifiedFollowing",
            date_generation_rule: "Forward"
          },
          index: { id: "USD_3M" },
          spread: 0.0,
          day_counter: "Actual360",
          payment_convention: "ModifiedFollowing"
        }
      },
      discounting_curve: "discount",
      forwarding_curve_leg1: "discount",
      forwarding_curve_leg2: "discount"
    }]
  },

  'zero-coupon-inflation-swap': {
    pricing: {
      as_of_date: '2025-01-15',
      curves: [{
        id: 'discount',
        day_counter: 'Actual365Fixed',
        interpolator: 'LogLinear',
        bootstrap_trait: 'Discount',
        reference_date: '2025-01-15',
        points: [
          {
            point_type: 'DepositHelper',
            point: {
              rate: 0.029,
              tenor_number: 6,
              tenor_time_unit: 'Months',
              fixing_days: 2,
              calendar: 'TARGET',
              business_day_convention: 'ModifiedFollowing',
              day_counter: 'Actual360',
            },
          },
          {
            point_type: 'SwapHelper',
            point: {
              rate: 0.026,
              tenor_number: 5,
              tenor_time_unit: 'Years',
              calendar: 'TARGET',
              sw_fixed_leg_frequency: 'Annual',
              sw_fixed_leg_convention: 'ModifiedFollowing',
              sw_fixed_leg_day_counter: 'Thirty360',
              float_index: { id: 'EUR_6M' },
              spread: 0,
            },
          },
        ],
      }],
      indices: [
        {
          id: 'EUR_6M',
          name: 'Euribor',
          index_type: 'Ibor',
          currency: 'EUR',
          tenor_number: 6,
          tenor_time_unit: 'Months',
          fixing_days: 2,
          calendar: 'TARGET',
          day_counter: 'Actual360',
          business_day_convention: 'ModifiedFollowing',
          end_of_month: false,
        },
      ],
      inflation_indices: [
        {
          id: 'EUHICP',
          family_name: 'EU HICP',
          currency: 'EUR',
          calendar: 'TARGET',
          day_counter: 'Actual365Fixed',
          frequency: 'Monthly',
          availability_lag: { n: 2, unit: 'Months' },
          observation_lag: { n: 3, unit: 'Months' },
          interpolated: true,
          revised: false,
          kind: 'ZeroInflation',
          fixings: [
            { date: '2024-10-01', value: 100.0 },
            { date: '2024-11-01', value: 100.2 },
            { date: '2024-12-01', value: 100.4 },
          ],
        },
      ],
      inflation_curves: [{
        id: 'HICP_ZC',
        reference_date: '2025-01-15',
        calendar: 'TARGET',
        business_day_convention: 'ModifiedFollowing',
        day_counter: 'Actual365Fixed',
        interpolator: 'Linear',
        bootstrap_accuracy: 1.0e-12,
        kind: 'ZeroInflation',
        index_id: 'EUHICP',
        discount_curve_id: 'discount',
        allow_extrapolation: true,
        points: [
          {
            point_type: 'ZeroCouponInflationSwapHelper',
            point: {
              quote_value: 0.02,
              swap_observation_lag: { n: 3, unit: 'Months' },
              tenor: { n: 1, unit: 'Years' },
              calendar: 'TARGET',
              payment_convention: 'ModifiedFollowing',
              day_counter: 'Actual365Fixed',
              observation_interpolation: 'Linear',
            },
          },
          {
            point_type: 'ZeroCouponInflationSwapHelper',
            point: {
              quote_value: 0.021,
              swap_observation_lag: { n: 3, unit: 'Months' },
              tenor: { n: 2, unit: 'Years' },
              calendar: 'TARGET',
              payment_convention: 'ModifiedFollowing',
              day_counter: 'Actual365Fixed',
              observation_interpolation: 'Linear',
            },
          },
        ],
      }],
    },
    swaps: [{
      zero_coupon_inflation_swap: {
        swap_type: 'Payer',
        notional: 1000000,
        start_date: '2025-01-15',
        maturity_date: '2030-01-15',
        fixed_calendar: 'TARGET',
        fixed_convention: 'ModifiedFollowing',
        day_counter: 'Actual365Fixed',
        fixed_rate: 0.0217,
        inflation_index_id: 'EUHICP',
        observation_lag: { n: 3, unit: 'Months' },
        observation_interpolation: 'Linear',
        adjust_observation_dates: false,
        inflation_calendar: 'NullCalendar',
        inflation_convention: 'Following',
      },
      discounting_curve: 'discount',
      inflation_curve: 'HICP_ZC',
    }],
    include_flows: true,
  },

  'year-on-year-inflation-swap': {
    pricing: {
      as_of_date: '2025-01-15',
      curves: [{
        id: 'discount',
        day_counter: 'Actual365Fixed',
        interpolator: 'LogLinear',
        bootstrap_trait: 'Discount',
        reference_date: '2025-01-15',
        points: [
          {
            point_type: 'DepositHelper',
            point: {
              rate: 0.029,
              tenor_number: 6,
              tenor_time_unit: 'Months',
              fixing_days: 2,
              calendar: 'TARGET',
              business_day_convention: 'ModifiedFollowing',
              day_counter: 'Actual360',
            },
          },
          {
            point_type: 'SwapHelper',
            point: {
              rate: 0.026,
              tenor_number: 5,
              tenor_time_unit: 'Years',
              calendar: 'TARGET',
              sw_fixed_leg_frequency: 'Annual',
              sw_fixed_leg_convention: 'ModifiedFollowing',
              sw_fixed_leg_day_counter: 'Thirty360',
              float_index: { id: 'EUR_6M' },
              spread: 0,
            },
          },
        ],
      }],
      indices: [
        {
          id: 'EUR_6M',
          name: 'Euribor',
          index_type: 'Ibor',
          currency: 'EUR',
          tenor_number: 6,
          tenor_time_unit: 'Months',
          fixing_days: 2,
          calendar: 'TARGET',
          day_counter: 'Actual360',
          business_day_convention: 'ModifiedFollowing',
          end_of_month: false,
        },
      ],
      inflation_indices: [
        {
          id: 'EUHICP_YY',
          family_name: 'EU HICP YoY',
          currency: 'EUR',
          calendar: 'TARGET',
          day_counter: 'Actual365Fixed',
          frequency: 'Monthly',
          availability_lag: { n: 2, unit: 'Months' },
          observation_lag: { n: 3, unit: 'Months' },
          interpolated: true,
          revised: false,
          kind: 'YoYInflation',
          fixings: [
            { date: '2024-10-01', value: 0.018 },
            { date: '2024-11-01', value: 0.019 },
          ],
        },
      ],
      inflation_curves: [{
        id: 'HICP_YY',
        reference_date: '2025-01-15',
        calendar: 'TARGET',
        business_day_convention: 'ModifiedFollowing',
        day_counter: 'Actual365Fixed',
        interpolator: 'Linear',
        bootstrap_accuracy: 1.0e-12,
        kind: 'YoYInflation',
        index_id: 'EUHICP_YY',
        discount_curve_id: 'discount',
        allow_extrapolation: true,
        points: [
          {
            point_type: 'YearOnYearInflationSwapHelper',
            point: {
              quote_value: 0.02,
              swap_observation_lag: { n: 3, unit: 'Months' },
              tenor: { n: 1, unit: 'Years' },
              calendar: 'TARGET',
              payment_convention: 'ModifiedFollowing',
              day_counter: 'Actual365Fixed',
              observation_interpolation: 'Linear',
              nominal_curve_id: 'discount',
            },
          },
          {
            point_type: 'YearOnYearInflationSwapHelper',
            point: {
              quote_value: 0.021,
              swap_observation_lag: { n: 3, unit: 'Months' },
              tenor: { n: 2, unit: 'Years' },
              calendar: 'TARGET',
              payment_convention: 'ModifiedFollowing',
              day_counter: 'Actual365Fixed',
              observation_interpolation: 'Linear',
              nominal_curve_id: 'discount',
            },
          },
        ],
      }],
    },
    swaps: [{
      year_on_year_inflation_swap: {
        swap_type: 'Receiver',
        notional: 1000000,
        fixed_schedule: {
          effective_date: '2025-01-15',
          termination_date: '2027-01-15',
          calendar: 'TARGET',
          frequency: 'Annual',
          convention: 'ModifiedFollowing',
          termination_date_convention: 'ModifiedFollowing',
          date_generation_rule: 'Forward',
        },
        fixed_rate: 0.0204,
        fixed_day_counter: 'Actual365Fixed',
        yoy_schedule: {
          effective_date: '2025-01-15',
          termination_date: '2027-01-15',
          calendar: 'TARGET',
          frequency: 'Annual',
          convention: 'ModifiedFollowing',
          termination_date_convention: 'ModifiedFollowing',
          date_generation_rule: 'Forward',
        },
        inflation_index_id: 'EUHICP_YY',
        observation_lag: { n: 3, unit: 'Months' },
        observation_interpolation: 'Linear',
        spread: 0.0002,
        yoy_day_counter: 'Actual365Fixed',
        payment_calendar: 'TARGET',
        payment_convention: 'ModifiedFollowing',
      },
      discounting_curve: 'discount',
      inflation_curve: 'HICP_YY',
    }],
    include_flows: true,
  },

  'fixed-rate-bond': {
    pricing: {
      as_of_date: "2026-02-09",
      settlement_date: "2026-02-11",
      curves: [{
        id: "discount",
        day_counter: "Actual365Fixed",
        interpolator: "LogLinear",
        bootstrap_trait: "Discount",
        reference_date: "2026-02-09",
        points: [
          {
            point_type: "DepositHelper",
            point: {
              rate: 0.029,
              tenor_time_unit: "Months",
              tenor_number: 6,
              fixing_days: 2,
              calendar: "TARGET",
              business_day_convention: "ModifiedFollowing",
              day_counter: "Actual360"
            }
          },
          {
            point_type: "DepositHelper",
            point: {
              rate: 0.025,
              tenor_time_unit: "Years",
              tenor_number: 1,
              fixing_days: 2,
              calendar: "TARGET",
              business_day_convention: "ModifiedFollowing",
              day_counter: "Actual360"
            }
          },
          {
            point_type: "SwapHelper",
            point: {
              rate: 0.024,
              tenor_time_unit: "Years",
              tenor_number: 5,
              calendar: "TARGET",
              sw_fixed_leg_frequency: "Annual",
              sw_fixed_leg_convention: "ModifiedFollowing",
              sw_fixed_leg_day_counter: "Thirty360",
              float_index: { id: "EUR_6M" },
              spread: 0.0,
              fwd_start_days: 0
            }
          },
          {
            point_type: "SwapHelper",
            point: {
              rate: 0.027,
              tenor_time_unit: "Years",
              tenor_number: 10,
              calendar: "TARGET",
              sw_fixed_leg_frequency: "Annual",
              sw_fixed_leg_convention: "ModifiedFollowing",
              sw_fixed_leg_day_counter: "Thirty360",
              float_index: { id: "EUR_6M" },
              spread: 0.0,
              fwd_start_days: 0
            }
          }
        ]
      }],
      indices: [
        {
          id: "EUR_6M",
          name: "Euribor",
          index_type: "Ibor",
          currency: "EUR",
          tenor_number: 6,
          tenor_time_unit: "Months",
          fixing_days: 2,
          calendar: "TARGET",
          day_counter: "Actual360",
          business_day_convention: "ModifiedFollowing",
          end_of_month: false
        }
      ],
      bond_pricing_details: true,
      bond_pricing_flows: false
    },
    bonds: [{
      fixed_rate_bond: {
        settlement_days: 2,
        face_amount: 100,
        rate: 0.03,
        accrual_day_counter: "ActualActualBond",
        payment_convention: "ModifiedFollowing",
        redemption: 100.0,
        issue_date: "2025-03-15",
        schedule: {
          calendar: "TARGET",
          effective_date: "2025-03-15",
          termination_date: "2030-03-15",
          frequency: "Annual",
          convention: "ModifiedFollowing",
          termination_date_convention: "ModifiedFollowing",
          date_generation_rule: "Backward"
        }
      },
      discounting_curve: "discount",
      yield: {
        day_counter: "ActualActualBond",
        compounding: "Compounded",
        frequency: "Annual"
      }
    }]
  },

  'floating-rate-bond': {
    pricing: {
      as_of_date: "2026-02-09",
      settlement_date: "2026-02-11",
      indices: [
        {
          id: "EUR_6M",
          name: "Euribor",
          index_type: "Ibor",
          currency: "EUR",
          tenor_number: 6,
          tenor_time_unit: "Months",
          fixing_days: 2,
          calendar: "TARGET",
          day_counter: "Actual360",
          business_day_convention: "ModifiedFollowing",
          end_of_month: false
        }
      ],
      curves: [{
        id: "discount",
        day_counter: "Actual365Fixed",
        interpolator: "LogLinear",
        bootstrap_trait: "Discount",
        reference_date: "2026-02-09",
        points: [
          {
            point_type: "DepositHelper",
            point: {
              rate: 0.029,
              tenor_time_unit: "Months",
              tenor_number: 6,
              fixing_days: 2,
              calendar: "TARGET",
              business_day_convention: "ModifiedFollowing",
              day_counter: "Actual360"
            }
          },
          {
            point_type: "SwapHelper",
            point: {
              rate: 0.024,
              tenor_time_unit: "Years",
              tenor_number: 5,
              calendar: "TARGET",
              sw_fixed_leg_frequency: "Annual",
              sw_fixed_leg_convention: "ModifiedFollowing",
              sw_fixed_leg_day_counter: "Thirty360",
              float_index: { id: "EUR_6M" },
              spread: 0.0,
              fwd_start_days: 0
            }
          }
        ]
      }],
      coupon_pricers: [{
        id: "iborpricer",
        black_ibor_coupon_pricer: {
          optionlet_volatility: {
            settlement_days: 2,
            calendar: "TARGET",
            business_day_convention: "ModifiedFollowing",
            volatility: 0,
            day_counter: "Actual365Fixed"
          }
        }
      }],
      bond_pricing_details: false,
      bond_pricing_flows: false
    },
    bonds: [{
      floating_rate_bond: {
        settlement_days: 2,
        face_amount: 100,
        schedule: {
          calendar: "TARGET",
          effective_date: "2026-02-15",
          termination_date: "2029-02-15",
          frequency: "Semiannual",
          convention: "ModifiedFollowing",
          termination_date_convention: "ModifiedFollowing",
          date_generation_rule: "Backward"
        },
        index: { id: "EUR_6M" },
        accrual_day_counter: "Actual360",
        payment_convention: "ModifiedFollowing",
        fixing_days: 2,
        spread: 0.005,
        in_arrears: false,
        redemption: 100,
        issue_date: "2026-02-15"
      },
      discounting_curve: "discount",
      forwarding_curve: "discount",
      coupon_pricer: "iborpricer"
    }]
  },

  'fra': {
    pricing: {
      as_of_date: "2026-02-09",
      indices: [
        {
          id: "EUR_3M",
          name: "Euribor",
          index_type: "Ibor",
          currency: "EUR",
          tenor_number: 3,
          tenor_time_unit: "Months",
          fixing_days: 2,
          calendar: "TARGET",
          day_counter: "Actual360",
          business_day_convention: "ModifiedFollowing",
          end_of_month: false
        }
      ],
      curves: [{
        id: "discount",
        day_counter: "Actual365Fixed",
        interpolator: "LogLinear",
        bootstrap_trait: "Discount",
        reference_date: "2026-02-09",
        points: [
          {
            point_type: "DepositHelper",
            point: {
              rate: 0.029,
              tenor_time_unit: "Months",
              tenor_number: 3,
              fixing_days: 2,
              calendar: "TARGET",
              business_day_convention: "ModifiedFollowing",
              day_counter: "Actual360"
            }
          },
          {
            point_type: "DepositHelper",
            point: {
              rate: 0.0275,
              tenor_time_unit: "Months",
              tenor_number: 6,
              fixing_days: 2,
              calendar: "TARGET",
              business_day_convention: "ModifiedFollowing",
              day_counter: "Actual360"
            }
          },
          {
            point_type: "DepositHelper",
            point: {
              rate: 0.025,
              tenor_time_unit: "Years",
              tenor_number: 1,
              fixing_days: 2,
              calendar: "TARGET",
              business_day_convention: "ModifiedFollowing",
              day_counter: "Actual360"
            }
          }
        ]
      }]
    },
    fras: [{
      fra: {
        fra_type: "Long",
        notional: 10000000,
        start_date: "2026-05-11",
        maturity_date: "2026-08-11",
        strike: 0.028,
        index: { id: "EUR_3M" },
        day_counter: "Actual360",
        calendar: "TARGET",
        business_day_convention: "ModifiedFollowing"
      },
      discounting_curve: "discount",
      forwarding_curve: "discount"
    }]
  },

  'cap-floor': {
    pricing: {
      as_of_date: "2026-02-09",
      indices: [
        {
          id: "EUR_6M",
          name: "Euribor",
          index_type: "Ibor",
          currency: "EUR",
          tenor_number: 6,
          tenor_time_unit: "Months",
          fixing_days: 2,
          calendar: "TARGET",
          day_counter: "Actual360",
          business_day_convention: "ModifiedFollowing",
          end_of_month: false
        }
      ],
      curves: [{
        id: "discount",
        day_counter: "Actual365Fixed",
        interpolator: "LogLinear",
        bootstrap_trait: "Discount",
        reference_date: "2026-02-09",
        points: [
          {
            point_type: "DepositHelper",
            point: {
              rate: 0.029,
              tenor_time_unit: "Months",
              tenor_number: 6,
              fixing_days: 2,
              calendar: "TARGET",
              business_day_convention: "ModifiedFollowing",
              day_counter: "Actual360"
            }
          },
          {
            point_type: "SwapHelper",
            point: {
              rate: 0.025,
              tenor_time_unit: "Years",
              tenor_number: 2,
              calendar: "TARGET",
              sw_fixed_leg_frequency: "Annual",
              sw_fixed_leg_convention: "ModifiedFollowing",
              sw_fixed_leg_day_counter: "Thirty360",
              float_index: { id: "EUR_6M" },
              spread: 0.0,
              fwd_start_days: 0
            }
          },
          {
            point_type: "SwapHelper",
            point: {
              rate: 0.024,
              tenor_time_unit: "Years",
              tenor_number: 5,
              calendar: "TARGET",
              sw_fixed_leg_frequency: "Annual",
              sw_fixed_leg_convention: "ModifiedFollowing",
              sw_fixed_leg_day_counter: "Thirty360",
              float_index: { id: "EUR_6M" },
              spread: 0.0,
              fwd_start_days: 0
            }
          }
        ]
      }],
      vol_surfaces: [{
        id: "capvol",
        payload_type: "OptionletVolSpec",
        payload: {
          base: {
            reference_date: "2026-02-09",
            calendar: "TARGET",
            business_day_convention: "ModifiedFollowing",
            day_counter: "Actual365Fixed",
            shape: "Constant",
            volatility_type: "Normal",
            constant_vol: 0.006
          }
        }
      }],
      models: [{
        id: "capmodel",
        payload_type: "CapFloorModelSpec",
        payload: {
          model_type: "Bachelier"
        }
      }]
    },
    cap_floors: [{
      cap_floor: {
        cap_floor_type: "Cap",
        notional: 10000000,
        strike: 0.03,
        schedule: {
          calendar: "TARGET",
          effective_date: "2026-02-11",
          termination_date: "2031-02-11",
          frequency: "Semiannual",
          convention: "ModifiedFollowing",
          termination_date_convention: "ModifiedFollowing",
          date_generation_rule: "Forward"
        },
        index: { id: "EUR_6M" },
        day_counter: "Actual360",
        business_day_convention: "ModifiedFollowing"
      },
      discounting_curve: "discount",
      forwarding_curve: "discount",
      volatility: "capvol",
      model: "capmodel",
      include_details: true
    }]
  },

  'swaption': {
    pricing: {
      as_of_date: "2026-02-09",
      indices: [
        {
          id: "EUR_6M",
          name: "Euribor",
          index_type: "Ibor",
          currency: "EUR",
          tenor_number: 6,
          tenor_time_unit: "Months",
          fixing_days: 2,
          calendar: "TARGET",
          day_counter: "Actual360",
          business_day_convention: "ModifiedFollowing",
          end_of_month: false
        }
      ],
      curves: [{
        id: "discount",
        day_counter: "Actual365Fixed",
        interpolator: "LogLinear",
        bootstrap_trait: "Discount",
        reference_date: "2026-02-09",
        points: [
          {
            point_type: "DepositHelper",
            point: {
              rate: 0.029,
              tenor_time_unit: "Months",
              tenor_number: 6,
              fixing_days: 2,
              calendar: "TARGET",
              business_day_convention: "ModifiedFollowing",
              day_counter: "Actual360"
            }
          },
          {
            point_type: "SwapHelper",
            point: {
              rate: 0.025,
              tenor_time_unit: "Years",
              tenor_number: 2,
              calendar: "TARGET",
              sw_fixed_leg_frequency: "Annual",
              sw_fixed_leg_convention: "ModifiedFollowing",
              sw_fixed_leg_day_counter: "Thirty360",
              float_index: { id: "EUR_6M" },
              spread: 0.0,
              fwd_start_days: 0
            }
          },
          {
            point_type: "SwapHelper",
            point: {
              rate: 0.024,
              tenor_time_unit: "Years",
              tenor_number: 5,
              calendar: "TARGET",
              sw_fixed_leg_frequency: "Annual",
              sw_fixed_leg_convention: "ModifiedFollowing",
              sw_fixed_leg_day_counter: "Thirty360",
              float_index: { id: "EUR_6M" },
              spread: 0.0,
              fwd_start_days: 0
            }
          },
          {
            point_type: "SwapHelper",
            point: {
              rate: 0.027,
              tenor_time_unit: "Years",
              tenor_number: 10,
              calendar: "TARGET",
              sw_fixed_leg_frequency: "Annual",
              sw_fixed_leg_convention: "ModifiedFollowing",
              sw_fixed_leg_day_counter: "Thirty360",
              float_index: { id: "EUR_6M" },
              spread: 0.0,
              fwd_start_days: 0
            }
          }
        ]
      }],
      vol_surfaces: [{
        id: "swaptvol",
        payload_type: "SwaptionVolSpec",
        payload: {
          swap_index_id: "EUR_SWAP_6M",
          payload_type: "SwaptionVolConstantSpec",
          payload: {
            base: {
              reference_date: "2026-02-09",
              calendar: "TARGET",
              business_day_convention: "ModifiedFollowing",
              day_counter: "Actual365Fixed",
              volatility_type: "Normal",
              displacement: 0.0,
              constant_vol: 0.005
            }
          }
        }
      }],
      models: [{
        id: "swaptmodel",
        payload_type: "SwaptionModelSpec",
        payload: {
          model_type: "Bachelier"
        }
      }]
    },
    swaptions: [{
      swaption: {
        exercise_type: "European",
        settlement_type: "Physical",
        exercise_date: "2027-02-09",
        underlying_type: "VanillaSwap",
        underlying: {
          swap_type: "Payer",
          fixed_leg: {
            notional: 10000000,
            schedule: {
              calendar: "TARGET",
              effective_date: "2027-02-11",
              termination_date: "2032-02-11",
              frequency: "Annual",
              convention: "ModifiedFollowing",
              termination_date_convention: "ModifiedFollowing",
              date_generation_rule: "Forward"
            },
            rate: 0.025,
            day_counter: "Thirty360",
            payment_convention: "ModifiedFollowing"
          },
          floating_leg: {
            notional: 10000000,
            schedule: {
              calendar: "TARGET",
              effective_date: "2027-02-11",
              termination_date: "2032-02-11",
              frequency: "Semiannual",
              convention: "ModifiedFollowing",
              termination_date_convention: "ModifiedFollowing",
              date_generation_rule: "Forward"
            },
            index: { id: "EUR_6M" },
            spread: 0.0,
            day_counter: "Actual360",
            payment_convention: "ModifiedFollowing"
          }
        }
      },
      discounting_curve: "discount",
      forwarding_curve: "discount",
      volatility: "swaptvol",
      model: "swaptmodel"
    }]
  },

  'swaption-model-calibration': {
    pricing: {
      as_of_date: "2025-01-15",
      indices: [
        {
          id: "EUR_6M",
          name: "Euribor",
          index_type: "Ibor",
          currency: "EUR",
          tenor_number: 6,
          tenor_time_unit: "Months",
          fixing_days: 2,
          calendar: "TARGET",
          day_counter: "Actual360",
          business_day_convention: "ModifiedFollowing",
          end_of_month: false
        }
      ],
      swap_indices: [
        {
          id: "EUR_SWAP_6M",
          float_index_id: "EUR_6M",
          fixed_frequency: "Annual",
          fixed_day_counter: "Thirty360",
          fixed_leg_tenor_n: 1,
          fixed_leg_tenor_unit: "Years",
          fixed_leg_convention: "ModifiedFollowing",
          calendar: "TARGET",
          spot_days: 2
        }
      ],
      curves: [{
        id: "discount",
        day_counter: "Actual365Fixed",
        interpolator: "LogLinear",
        bootstrap_trait: "Discount",
        reference_date: "2025-01-15",
        points: [
          {
            point_type: "DepositHelper",
            point: {
              rate: 0.029,
              tenor_time_unit: "Months",
              tenor_number: 6,
              fixing_days: 2,
              calendar: "TARGET",
              business_day_convention: "ModifiedFollowing",
              day_counter: "Actual360"
            }
          },
          {
            point_type: "SwapHelper",
            point: {
              rate: 0.024,
              tenor_time_unit: "Years",
              tenor_number: 5,
              calendar: "TARGET",
              sw_fixed_leg_frequency: "Annual",
              sw_fixed_leg_convention: "ModifiedFollowing",
              sw_fixed_leg_day_counter: "Thirty360",
              float_index: { id: "EUR_6M" },
              spread: 0.0,
              fwd_start_days: 0
            }
          }
        ]
      }],
      vol_surfaces: [{
        id: "swaption_atm",
        payload_type: "SwaptionVolSpec",
        payload: {
          swap_index_id: "EUR_SWAP_6M",
          payload_type: "SwaptionVolAtmMatrixSpec",
          payload: {
            base: {
              reference_date: "2025-01-15",
              calendar: "TARGET",
              business_day_convention: "ModifiedFollowing",
              day_counter: "Actual365Fixed",
              volatility_type: "Normal"
            },
            expiries: [{ n: 1, unit: "Years" }, { n: 2, unit: "Years" }],
            tenors: [{ n: 5, unit: "Years" }, { n: 7, unit: "Years" }],
            vols: { n_1: 2, n_2: 2, values: [0.20, 0.21, 0.22, 0.23] }
          }
        }
      }],
      models: [{
        id: "hw_inline_model",
        payload_type: "SwaptionModelSpec",
        payload: {
          model_type: "HullWhiteLattice",
          param_mode: "Calibrate",
          hw_a: 0.03,
          hw_sigma: 0.01,
          lattice_steps: 50,
          hw_calibration: {
            swaption_vol_id: "swaption_atm",
            discount_curve_id: "discount",
            forwarding_curve_id: "discount",
            swap_index_id: "EUR_SWAP_6M"
          }
        }
      }]
    },
    model_id: "hw_inline_model"
  },

  'swaption-bermudan-with-model': {
    pricing: {
      as_of_date: "2025-01-15",
      indices: [
        {
          id: "EUR_6M",
          name: "Euribor",
          index_type: "Ibor",
          currency: "EUR",
          tenor_number: 6,
          tenor_time_unit: "Months",
          fixing_days: 2,
          calendar: "TARGET",
          day_counter: "Actual360",
          business_day_convention: "ModifiedFollowing",
          end_of_month: false
        }
      ],
      curves: [{
        id: "discount",
        day_counter: "Actual365Fixed",
        interpolator: "LogLinear",
        bootstrap_trait: "Discount",
        reference_date: "2025-01-15",
        points: [
          {
            point_type: "DepositHelper",
            point: {
              rate: 0.029,
              tenor_time_unit: "Months",
              tenor_number: 6,
              fixing_days: 2,
              calendar: "TARGET",
              business_day_convention: "ModifiedFollowing",
              day_counter: "Actual360"
            }
          },
          {
            point_type: "SwapHelper",
            point: {
              rate: 0.024,
              tenor_time_unit: "Years",
              tenor_number: 5,
              calendar: "TARGET",
              sw_fixed_leg_frequency: "Annual",
              sw_fixed_leg_convention: "ModifiedFollowing",
              sw_fixed_leg_day_counter: "Thirty360",
              float_index: { id: "EUR_6M" },
              spread: 0.0,
              fwd_start_days: 0
            }
          }
        ]
      }],
      vol_surfaces: [{
        id: "swaption_atm",
        payload_type: "SwaptionVolSpec",
        payload: {
          swap_index_id: "EUR_SWAP_6M",
          payload_type: "SwaptionVolConstantSpec",
          payload: {
            base: {
              reference_date: "2025-01-15",
              calendar: "TARGET",
              business_day_convention: "ModifiedFollowing",
              day_counter: "Actual365Fixed",
              volatility_type: "Normal",
              constant_vol: 0.21
            }
          }
        }
      }],
      models: [{
        id: "hw_explicit_model",
        payload_type: "SwaptionModelSpec",
        payload: {
          model_type: "HullWhiteLattice",
          param_mode: "Explicit",
          hw_a: 0.03,
          hw_sigma: 0.01,
          lattice_steps: 50
        }
      }]
    },
    swaptions: [{
      swaption: {
        exercise_type: "Bermudan",
        settlement_type: "Physical",
        exercise_dates: ["2026-01-15", "2027-01-15", "2028-01-15"],
        underlying_type: "VanillaSwap",
        underlying: {
          swap_type: "Payer",
          fixed_leg: {
            notional: 1000000,
            schedule: {
              calendar: "TARGET",
              effective_date: "2026-01-17",
              termination_date: "2031-01-17",
              frequency: "Annual",
              convention: "ModifiedFollowing",
              termination_date_convention: "ModifiedFollowing",
              date_generation_rule: "Forward"
            },
            rate: 0.035,
            day_counter: "Thirty360",
            payment_convention: "ModifiedFollowing"
          },
          floating_leg: {
            notional: 1000000,
            schedule: {
              calendar: "TARGET",
              effective_date: "2026-01-17",
              termination_date: "2031-01-17",
              frequency: "Semiannual",
              convention: "ModifiedFollowing",
              termination_date_convention: "ModifiedFollowing",
              date_generation_rule: "Forward"
            },
            index: { id: "EUR_6M" },
            spread: 0.0,
            day_counter: "Actual360",
            payment_convention: "ModifiedFollowing",
            fixing_days: 2,
            in_arrears: false
          }
        }
      },
      discounting_curve: "discount",
      forwarding_curve: "discount",
      volatility: "swaption_atm",
      model: "hw_explicit_model"
    }]
  },

  'cds': {
    pricing: {
      as_of_date: "2026-02-09",
      curves: [{
        id: "discount",
        day_counter: "Actual365Fixed",
        interpolator: "LogLinear",
        bootstrap_trait: "Discount",
        reference_date: "2026-02-09",
        points: [
          {
            point_type: "DepositHelper",
            point: {
              rate: 0.029,
              tenor_time_unit: "Months",
              tenor_number: 6,
              fixing_days: 2,
              calendar: "TARGET",
              business_day_convention: "ModifiedFollowing",
              day_counter: "Actual360"
            }
          },
          {
            point_type: "DepositHelper",
            point: {
              rate: 0.025,
              tenor_time_unit: "Years",
              tenor_number: 1,
              fixing_days: 2,
              calendar: "TARGET",
              business_day_convention: "ModifiedFollowing",
              day_counter: "Actual360"
            }
          },
          {
            point_type: "SwapHelper",
            point: {
              rate: 0.024,
              tenor_time_unit: "Years",
              tenor_number: 5,
              calendar: "TARGET",
              sw_fixed_leg_frequency: "Annual",
              sw_fixed_leg_convention: "ModifiedFollowing",
              sw_fixed_leg_day_counter: "Thirty360",
              float_index: { id: "EUR_6M" },
              spread: 0.0,
              fwd_start_days: 0
            }
          }
        ]
      }],
      indices: [
        {
          id: "EUR_6M",
          name: "Euribor",
          index_type: "Ibor",
          currency: "EUR",
          tenor_number: 6,
          tenor_time_unit: "Months",
          fixing_days: 2,
          calendar: "TARGET",
          day_counter: "Actual360",
          business_day_convention: "ModifiedFollowing",
          end_of_month: false
        }
      ],
      credit_curves: [{
        id: "inline_credit_curve",
        reference_date: "2026-02-09",
        calendar: "TARGET",
        day_counter: "Actual365Fixed",
        recovery_rate: 0.4,
        curve_interpolator: "LogLinear",
        helper_conventions: {
          settlement_days: 0,
          frequency: "Quarterly",
          business_day_convention: "Following",
          date_generation_rule: "TwentiethIMM",
          last_period_day_counter: "Actual365Fixed",
          settles_accrual: true,
          pays_at_default_time: true,
          rebates_accrual: true,
          helper_model: "MidPoint"
        },
        quotes: [],
        flat_hazard_rate: 0.02
      }],
      models: [{
        id: "cds_midpoint",
        payload_type: "CdsModelSpec",
        payload: {
          engine_type: "MidPoint"
        }
      }]
    },
    cds_list: [{
      cds: {
        side: "Buyer",
        notional: 10000000,
        running_coupon: 0.01,
        schedule: {
          calendar: "TARGET",
          effective_date: "2026-02-11",
          termination_date: "2031-02-11",
          frequency: "Quarterly",
          convention: "ModifiedFollowing",
          termination_date_convention: "ModifiedFollowing",
          date_generation_rule: "CDS"
        },
        day_counter: "Actual360",
        business_day_convention: "ModifiedFollowing"
      },
      discounting_curve: "discount",
      credit_curve_id: "inline_credit_curve",
      model: "cds_midpoint"
    }]
  }
};

function normalizeSampleTenors(value: unknown): unknown {
  if (Array.isArray(value)) {
    return value.map(normalizeSampleTenors);
  }
  if (!value || typeof value !== 'object') {
    return value;
  }

  const source = value as Record<string, unknown>;
  const out: Record<string, unknown> = {};

  for (const [key, v] of Object.entries(source)) {
    out[key] = normalizeSampleTenors(v);
  }

  const hasLegacyNumber = typeof source.tenor_number === 'number';
  const hasLegacyUnit = typeof source.tenor_time_unit === 'string';
  const hasNewTenor = !!source.tenor && typeof source.tenor === 'object';
  if (!hasNewTenor && hasLegacyNumber && hasLegacyUnit) {
    out.tenor = {
      n: source.tenor_number,
      unit: source.tenor_time_unit,
    };
  }

  delete out.tenor_number;
  delete out.tenor_time_unit;
  return out;
}

export function getSampleRequest(productType: string): string {
  const request = SAMPLE_REQUESTS[productType];
  if (request) {
    return JSON.stringify(normalizeQuantraRequestForApi(normalizeSampleTenors(request)), null, 2);
  }
  return JSON.stringify({ error: `No sample for ${productType}` }, null, 2);
}